import { useState, useEffect, FC } from "react";
import { CalendarOutlined, ProfileOutlined } from "@ant-design/icons";
import { FieldData } from "../../components/ApplicationCreate/ApplicationCreate";
import { IConstructorJsxFilteredListAgent } from "../../interfaces/Constructor/IConstructorJsxFilteredListAgent";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import { UI_ITOModuleTitle } from "../../UI_ITO/indexUI";
import {
  SELECT_AGENT,
  SELECT_AGENT_BY_ID,
  SELECT_LIST_AGENT_ACTIVE,
  SELECT_LIST_AGENT_ARCHIVE,
} from "../../store/selectors/listAgentSelector";
import {
  CHANGE_AGENT_FORM_DISABLE,
  CHANGE_AGENT_FORM_INITIAL,
  CHANGE_AGENT_FORM_TYPE,
  CHANGE_SELECTED_AGENT,
  IAgent,
} from "../../store/slice/listAgentSlice/listAgentSlice";
import { useNavigate, useParams } from "react-router-dom";

import classes from "./style/PageListAgent.module.css";
import { IListAgentTable } from "../../interfaces/ListTable/IListAgentTable";
import {
  ConfigProvider,
  Pagination,
  Select,
  Table,
  TableColumnsType,
} from "antd";
import { selectViewShowBy } from "../../constants/selectViewShowBy";
import { FilterAgentForm } from "../../components/ListAgent/FilterAgentForm/FilterAgentForm";

// страница списка агетов
export const PageListAgentIndividual = () => {
  const { id } = useParams();
  const findAgent = useAppSelector(SELECT_AGENT_BY_ID(id ? +id : undefined));
  const dispatch = useAppDispatch();
  const listAgentActive = useAppSelector(SELECT_LIST_AGENT_ACTIVE);
  const listAgentArchive = useAppSelector(SELECT_LIST_AGENT_ARCHIVE);
  const [filteredListAgentActive, setFilteredListAgentActive] =
    useState<IAgent[]>(listAgentActive);

  function changeSelectedAgent(agent: IAgent) {
    dispatch(CHANGE_AGENT_FORM_INITIAL(agent));
    dispatch(CHANGE_SELECTED_AGENT(agent));
    dispatch(CHANGE_AGENT_FORM_DISABLE(true));
    dispatch(CHANGE_AGENT_FORM_TYPE("INFO"));
  }

  // отображение агентов в архивном и активном списке, установка найденного пользователя
  useEffect(() => {
    setFilteredListAgentActive(listAgentActive);
    if (findAgent) {
      changeSelectedAgent(findAgent);
    }
  }, [listAgentActive, listAgentArchive]);

  const navigate = useNavigate();

  const columnsApplication: TableColumnsType<IListAgentTable> = [
    {
      title: "Наименование организации",
      width: 300,
      dataIndex: "organizationName",
      render: (organizationName) => (
        <span
          style={{ color: "#3c79ff", cursor: "pointer" }}
          onClick={() => {
            navigate(`/agent/${organizationName.id}`);
          }}
        >
          {organizationName.name}
        </span>
      ),
    },
    {
      title: "ИНН",
      dataIndex: "inn",
      width: 75,
    },
    {
      title: "ФИО контактного лица",
      dataIndex: "fullName",
      width: 120,
    },
    {
      title: "Номер контактного лица",
      dataIndex: "phoneNumber",
      width: 125,
    },

    {
      title: "Адрес эл.почты",
      dataIndex: "email",
      width: 1,
    },
  ];

  const dataTableAgentSource: IListAgentTable[] = filteredListAgentActive?.map(
    (item: IAgent) => {
      const {
        id,
        organization,
        inn,
        surname,
        name,
        patronymic,
        phone_number,
        email,
      } = item;

      return {
        organizationName: { name: organization?.name || "", id },
        email,
        id,
        fullName: `${surname} ${name[0].toUpperCase()}.${patronymic && patronymic?.length > 0 ? `${patronymic[0].toUpperCase()}.` : ""}`,
        inn: inn ? inn : "",
        phoneNumber: phone_number ? phone_number : "",
      };
    },
  );

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            borderRadius: 20,
            rowHoverBg: "#eaeaea",
            headerBorderRadius: 12,
            headerBg: "transparent",
            rowExpandedBg: "transparent",
            colorBorder: "black",
            colorBorderBg: "black",
          },
          Button: {
            defaultBorderColor: "rgb(0 0 0 / 20%)",
            defaultColor: "rgba(0, 0, 0, 0.65)",
          },
        },
      }}
    >
      <>
        <div className={classes.listAgent}>
          <div className={classes.listAgentPageHeader}>
            <UI_ITOModuleTitle title="Агенты c ИУ" />
            <FilterAgentForm />
          </div>

          <div className={classes.agentListContainer}>
            <Table
              className={classes.listAgentTable}
              rowClassName={classes.tableRow}
              columns={columnsApplication}
              dataSource={dataTableAgentSource}
              pagination={false}
              size="small"
            />
          </div>

          <div className={classes.paginationContainer}>
            <div>
              Показывать по:{" "}
              <Select
                options={selectViewShowBy}
                className={classes.paginationSelect}
              />
            </div>

            <Pagination
              className={classes.pagination}
              total={10}
              defaultPageSize={2}
            />
          </div>
        </div>
      </>
    </ConfigProvider>
  );
};
